<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    <span>
      {{ vendings.length }}
      {{ $tc("vending.vending", vendings.length) }}
    </span>

    <button class="button" @click="$emit('get-vendings')">
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  mixins: [common],

  components: {
    goToDashboardButton
  },

  computed: {
    ...mapGetters(["vendings"])
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
